import { useEffect, useState } from 'react';

// Tracks how far a tall element (the article body) has been scrolled, as a
// 0-100 percentage. Used for the reading progress bar above the post.
export default function useScrollProgress(ref) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let frame = null;

    const update = () => {
      frame = null;

      const node = ref?.current;
      if (!node) {
        setProgress(0);
        return;
      }

      const rect = node.getBoundingClientRect();
      const viewport = window.innerHeight || 0;
      const scrollable = rect.height + viewport;
      const scrolled = Math.min(Math.max(-rect.top, 0), scrollable);

      setProgress(scrollable > 0 ? (scrolled / scrollable) * 100 : 0);
    };

    const onScroll = () => {
      if (frame === null) {
        frame = window.requestAnimationFrame(update);
      }
    };

    update();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    return () => {
      if (frame !== null) {
        window.cancelAnimationFrame(frame);
      }
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, [ref]);

  return progress;
}